import React from 'react';
import SupportEditEventEffect from './SupportEditEventEffect';

const SupportEditEventOption = ({ option, onChange, onDelete, onClone }) => {

    // -- Field Updates --
    const handleFieldChange = (field, value) => {
        onChange({ ...option, [field]: value });
    };

    // -- Effect Management --
    const handleAddEffect = () => {
        const newEffects = [...(option.effects || []), { text: '', type: '', bonus: 0, skill_id: null, random: false }];
        onChange({ ...option, effects: newEffects });
    };

    const handleUpdateEffect = (index, updatedEffect) => {
        const newEffects = [...option.effects];
        newEffects[index] = updatedEffect;
        onChange({ ...option, effects: newEffects });
    };

    const handleDeleteEffect = (index) => {
        const newEffects = option.effects.filter((_, i) => i !== index);
        onChange({ ...option, effects: newEffects });
    };

    return (
        <div className="bg-white border text-sm rounded shadow-sm p-3 relative">
            {/* Toolbar */}
            <div className="flex justify-end gap-2 mb-2 border-b pb-2">
                <button
                    onClick={onClone}
                    className="text-xs bg-indigo-50 text-indigo-600 px-2 py-1 rounded border border-indigo-100 hover:bg-indigo-100 whitespace-nowrap"
                    title="Clone this option as a new variant"
                >
                    + Clone/Var
                </button>
                <button
                    onClick={onDelete}
                    className="text-red-500 hover:text-red-700 ml-2"
                    title={option.id ? "Delete from DB" : "Remove from list"}
                >
                    🗑️
                </button>
            </div>

            <div className="flex justify-between items-start mb-2">
                <div className="flex gap-2 w-full">
                    <div className="flex-1">
                        <label className="text-xs text-gray-500">Option Name</label>
                        <input
                            type="text"
                            value={option.option_name}
                            onChange={(e) => handleFieldChange('option_name', e.target.value)}
                            className="w-full border p-1 rounded font-bold"
                        />
                    </div>
                    <div className="w-24">
                        <label className="text-xs text-gray-500">Variant #</label>
                        <input
                            type="number"
                            value={option.variant}
                            onChange={(e) => handleFieldChange('variant', parseInt(e.target.value) || 1)}
                            className="w-full border p-1 rounded"
                        />
                    </div>
                </div>
            </div>

            {/* Effects */}
            <div className="space-y-2 pl-4 border-l-2 border-indigo-100">
                <div className="text-xs font-bold text-gray-400 uppercase mb-1">Effects</div>
                {option.effects && option.effects.map((eff, effIdx) => (
                    <SupportEditEventEffect
                        key={effIdx}
                        effect={eff}
                        onChange={(updatedEffect) => handleUpdateEffect(effIdx, updatedEffect)}
                        onDelete={() => handleDeleteEffect(effIdx)}
                    />
                ))}
                <button onClick={handleAddEffect} className="text-xs text-indigo-600 hover:underline">+ Add Effect</button>
            </div>
        </div>
    );
};

export default SupportEditEventOption;
